import React, { Component } from 'react';
import Header from 'components/layout/header';
import Sidebar from 'components/layout/sidebar';
// import Breadcrumb from 'components/layout/breadcrumb';
// import Aside from 'components/layout/aside';
import Footer from 'components/layout/footer';
import Routes from 'routes/routes'

class Layout extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar />
          <main className="main">
            {/* <Breadcrumb /> */}
            <div style={{ marginBottom: "1.5rem" }}></div>
            <div className="container-fluid">
              <div className="animated fadeIn">
                <Routes />
              </div>
            </div>
          </main>
          {/* <Aside /> */}
        </div>
        <Footer />
      </div>
    )
  }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/components/layout/index.jsx